---
title: Email & mailbox setup
parent: Documentation
parentHref: /docs
---

# Setting up your email mailbox

Your TOBY plan includes a professional email address matching your domain (for example, info@your-domain.de) with a **15 GB mailbox (Maxi-Postfach)**, plus unlimited email forwarding addresses. Need more mailboxes or extra storage? You can add another 15 GB mailbox at any time — see the [price list](/pricing).

## 1. Create your mailbox in TOBY

1. Open **Settings → Email** in TOBY.
2. Choose the address you want (such as info@, hello@, or contact@) and create the mailbox.
3. **Copy your password:** TOBY shows your generated mailbox password once right after creation. Copy or save it before closing the window. (If you ever lose it, you can generate a new password with one click under **Settings → Email** — your existing emails stay safe.)

## 2. Read and send email in your browser (Webmail)

You can open your inbox from any computer or phone browser without installing an app:

- **Webmail address:** [mail.tobysite.com/SOGo](https://mail.tobysite.com/SOGo)
- **Username:** your full email address (e.g. info@your-domain.de)
- **Password:** the mailbox password from **Settings → Email**

## 3. Connect your phone or computer (IMAP & SMTP)

To read and send emails in **Apple Mail (iPhone, iPad, Mac)**, **Gmail / Android Mail**, **Outlook**, or **Thunderbird**, add a new **IMAP** account in your mail app and enter these server settings:

| Setting | Value |
| --- | --- |
| **Account type** | IMAP |
| **Email address / Username** | Your full email address (e.g. info@your-domain.de) |
| **Password** | Your mailbox password from Settings → Email |
| **Incoming mail server (IMAP)** | mail.tobysite.com |
| **Incoming port** | 993 (SSL/TLS) |
| **Outgoing mail server (SMTP)** | mail.tobysite.com |
| **Outgoing port** | 465 (SSL/TLS) or 587 (STARTTLS) |

> **Important:** Make sure you enter your **complete email address** (including @your-domain.de) as the username for **both** the incoming (IMAP) and outgoing (SMTP) server.

### Step by step on iPhone & iPad (iOS Mail)

1. Open the iPhone **Settings** app → **Apps** → **Mail** → **Mail Accounts** → **Add Account** → **Other** → **Add Mail Account**.
2. Enter your name, your full email address, your mailbox password, and a short description. Tap **Next**.
3. Keep **IMAP** selected at the top.
4. Under **Incoming Mail Server** and **Outgoing Mail Server**, enter mail.tobysite.com as the Host Name, your full email address as the User Name, and your mailbox password.
5. Tap **Next** and then **Save**.

### Step by step on Android (Gmail app)

1. Open the **Gmail** app, tap your profile picture in the top right → **Add another account** → **Other**.
2. Enter your full email address and tap **Manual setup** → **Personal (IMAP)**, then enter your password.
3. For the **Incoming server**, set the server to mail.tobysite.com, port 993, and security type SSL/TLS.
4. For the **Outgoing SMTP server**, set the server to mail.tobysite.com, port 465 (SSL/TLS), and make sure **Require sign-in** is enabled with your full email address.
5. Tap **Next** to finish.

Next: [Newsletter & announcements](/docs/newsletter).
